<template>
  <!-- Read/view counter pill: an eye glyph + the count. `overlay` pins it over a
       media thumbnail (top-right); without it the pill flows inline. -->
  <span
    class="vc"
    :class="{ 'vc--overlay': overlay }"
    :aria-label="`${$t('common.views')}: ${count}`"
  >
    <svg class="vc__icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2" />
    </svg>
    <span class="vc__n">{{ formatted }}</span>
  </span>
</template>

<script>
export default {
  name: 'ViewCount',
  props: {
    count: { type: Number, default: 0 },
    // Absolutely position the pill in the top-right of a `position: relative`
    // media container (used on image/photo thumbnails).
    overlay: { type: Boolean, default: false }
  },
  computed: {
    // Compact large numbers so the pill stays small: 1234 → "1.2k", 25000 → "25k".
    formatted() {
      const n = Number(this.count) || 0
      if (n < 1000) return String(n)
      const k = n / 1000
      return (k < 10 ? k.toFixed(1).replace(/\.0$/, '') : Math.round(k)) + 'k'
    }
  }
}
</script>

<style scoped>
.vc {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  color: inherit;
  white-space: nowrap;
}
.vc__icon {
  width: 1.15em;
  height: 1.15em;
  flex: none;
}
.vc__n { font-variant-numeric: tabular-nums; }

/* Overlay variant: a translucent dark chip pinned over a thumbnail. */
.vc--overlay {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 2;
  padding: 5px 9px;
  border-radius: 8px;
  background: rgba(15, 23, 42, 0.62);
  color: #fff;
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
}
</style>
